import "./ManageAvailabilityCard.css";
import moment from "moment";

const ManageAvailabilityCard = ({
  end,
  heading,
  start,
  onClick,
  day_off,
  containerStyle,
}) => {
  const formatSlotTiming = (time) => {
    const dateWithTimeString = `${new Date().toDateString()} ${time}`;
    return moment(dateWithTimeString).format("hh:mm a");
  };

  return (
    <div className="ManageAvailabilityCard" style={containerStyle}>
      <div className="content">
        <h4 className="heading4">{heading}</h4>
        <p
          className={
            day_off ? "bodyText dayOffText" : "bodyText startAndEndTimeText"
          }
        >
          {day_off
            ? "Day Off"
            : `${formatSlotTiming(start)} - ${formatSlotTiming(end)}`}
        </p>
      </div>
      <div className="editIcon" onClick={onClick}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          className="icon"
        >
          <path
            id="Icon_material-edit"
            data-name="Icon material-edit"
            d="M4.5,20.33V24.5H8.666L20.953,12.209,16.787,8.043ZM24.175,8.987a1.106,1.106,0,0,0,0-1.566l-2.6-2.6a1.106,1.106,0,0,0-1.566,0L17.976,6.854l4.166,4.166Z"
            transform="translate(-4.5 -4.496)"
            fill="#e23744"
          />
        </svg>
      </div>
    </div>
  );
};

export default ManageAvailabilityCard;
